import { Result } from '@empathy/search-types';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { ClientEventCallbacks } from '../../../models/config';
import { ClientEventsDispatcher } from '../../../services';
import { Dictionary, isArrayEmptyOrNull, mapWishlistToResults } from '../../../utils';
import { UpdateResultMutationPayload } from '../../search/mutations/update-result.mutation';
import { CORE_ACTIONS_KEYS, CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreAction, CoreContext } from '../core.interfaces';

export class WishlistAction implements CoreAction {

  private clientEventsDispatcher: ClientEventsDispatcher;

  actions = {
    [CORE_ACTIONS_KEYS.callAddToWishlistClientEvent]:
      ({ commit, rootState }: CoreContext, data: UpdateResultMutationPayload) => {
        this.initDependencies();
        this.clientEventsDispatcher.dispatch({ eventName: ClientEventCallbacks.addToWishlist, data });
      },
    [CORE_ACTIONS_KEYS.callRemoveFromWishlistClientEvent]:
      ({ commit, rootState }: CoreContext, data: UpdateResultMutationPayload) => {
        this.initDependencies();
        this.clientEventsDispatcher.dispatch({ eventName: ClientEventCallbacks.removeFromWishlist, data });
      },
    [CORE_ACTIONS_KEYS.callGetWishlistClientEvent]: () => {
      this.initDependencies();
      this.clientEventsDispatcher.dispatch({ eventName: ClientEventCallbacks.getWishlist });
    },
    [CORE_ACTIONS_KEYS.mapWishlistToExistingResults]:
      ({ rootState, state, commit}: CoreContext) => {
        const nextQueriesResults = rootState.querySignals.nextQueries.map(nextQuery => nextQuery.results);
        const fallbackFiltersResults = Object.values(rootState.noResults.fallbackFiltersResults);
        const existingResults: Array<Result[]> = [
          rootState.empathize.identifierSuggestions,
          rootState.empathize.resultsSuggestions,
          rootState.emptySearch.discoveryWall.clicksRecommendations.results,
          rootState.emptySearch.discoveryWall.queriesRecommendations.results,
          rootState.emptySearch.discoveryWall.sectionRecommendations.results,
          rootState.emptySearch.discoveryWall.userRecommendations.results,
          ...fallbackFiltersResults,
          ...nextQueriesResults
        ];
        commit(CORE_MUTATIONS_KEYS.mapWishlistToExistingResults, existingResults);
      }
  };

  private initDependencies(): void {
    this.clientEventsDispatcher = container.get<ClientEventsDispatcher>(DEPENDENCIES.ClientEventsDispatcher);
  }
}
